import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { shortenText } from "utils/shorten-text";

const PromotionItem = () => {
  return (
    <tr>
      <td>
        <DiscographyTitle>
          {/* <DiscographyListImage
            src={isTrack ? coverImage : data.coverArtPath}
            alt="discography"
          /> */}
          <div>
            <div style={{ cursor: "pointer" }}>
              <Typography color={Colors.white300} weight={"medium"} mb="0.4">
                {/* {title} */}
                The Vibe
              </Typography>
            </div>

            <Typography size="s" color={Colors.grey400}>
              {/* {shortenText(artist?.name, 50)} */}
              Vectra, Sammy T Beatz
            </Typography>
          </div>
        </DiscographyTitle>
      </td>
      <td>
        <Typography color={Colors.white300} mr="5">
          Radio, TV
          {/* {type.charAt(0).toUpperCase() + type.slice(1)} */}
        </Typography>
      </td>
      <td>
        <StatusContainer>
          <Status status="released" />
          <Typography>Active</Typography>
        </StatusContainer>
      </td>
    </tr>
  );
};

export default PromotionItem;

const DiscographyTitle = styled.div`
  padding-left: 3.2rem;
  display: flex;
  align-items: center;
`;

const DiscographyListImage = styled.img`
  width: 3.3rem;
  height: 3.3rem;
  border-radius: 0.4rem;
  margin-right: 1.6rem;
  object-fit: scale-down;
`;

const StatusContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const Status = styled.div<{ status: string }>`
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  position: relative;
  background-color: ${(props) =>
    props.status === "released"
      ? Colors.success
      : props.status === "inactive"
      ? Colors.danger
      : Colors.yellow500};
`;
